import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/footer/Energie solidaire.png")